import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function AppSection() {
  const { ref: sectionRef, visible: sectionVisible } = useScrollReveal(0.08);

  return (
    <section id="app" className="py-16 md:py-24 px-4 md:px-6 bg-primary-500">
      <div ref={sectionRef} className={`max-w-5xl mx-auto ${sectionVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}`}>
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 border border-white/20 mb-4">
              <i className="ri-smartphone-line text-white text-xs w-4 h-4 flex items-center justify-center"></i>
              <span className="text-xs font-medium text-white/80 whitespace-nowrap">随时随地 · 畅快阅读</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
              移动畅读
            </h2>
            <div className="w-16 h-0.5 bg-white/40 mx-auto lg:mx-0 mb-6"></div>
            <p className="text-base md:text-lg text-white/90 leading-relaxed max-w-lg">
              触手漫画全面适配移动端浏览，采用下拉式畅快阅读模式，无需翻页即可沉浸式体验触手漫画的魅力。
              无论你在地铁、咖啡厅还是床上，打开手机就能随时随地畅读你喜爱的触手漫画，
              海量触手漫画全集随身携带，让阅读不再受时间和地点限制。
            </p>
            <ul className="mt-6 space-y-3 text-white/80 text-sm">
              {[
                '下拉式阅读：一滑到底，无需频繁翻页',
                '自适应排版：完美适配各种屏幕尺寸',
                '夜间模式：保护视力，深夜追更无压力',
                '离线缓存：提前加载，流量也能畅快读',
              ].map((item) => (
                <li key={item} className="flex items-center gap-2">
                  <i className="ri-check-line text-accent-300 w-4 h-4 flex items-center justify-center"></i>
                  {item}
                </li>
              ))}
            </ul>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-8">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-white text-primary-600 hover:bg-white/90 font-semibold text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line w-4 h-4 flex items-center justify-center"></i>
                手机端打开
              </a>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <div className="relative w-64 h-[480px] bg-background-950 rounded-3xl border-4 border-background-800 overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-8 bg-background-900 flex items-center justify-center rounded-t-2xl">
                <div className="w-16 h-1 bg-background-600 rounded-full"></div>
              </div>
              <div className="pt-10 px-4 h-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20mockup%20showing%20dark%20theme%20manga%20reading%20app%20interface%2C%20crimson%20and%20dark%20tones%2C%20comic%20reading%20layout%20with%20vertical%20scroll%2C%20clean%20UI%2C%20atmospheric%20dark%20mode%20design&width=500&height=900&seq=app-mock-01&orientation=portrait"
                  alt="触手漫画移动端阅读界面展示"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}